import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "src/environments/environment";
import {DiscussionParticipant} from "src/app/modules/discussions/interfaces/discussion.interface";

@Injectable({providedIn: "root"})
export class UserSafetyService {
  private readonly base = `${environment.apiDomain}/users/me/blocked`;
  constructor(private readonly http: HttpClient) {}

  listBlocked() {
    return this.http.get<DiscussionParticipant[]>(this.base);
  }

  setBlocked(id: string, blocked: boolean) {
    const url = `${this.base}/${id}`;
    return blocked ? this.http.put(url, {}) : this.http.delete(url);
  }
}
